import { render } from "./TagsModal.vue?vue&type=template&id=6fb24c14&scoped=true"
import script from "./TagsModal.vue?vue&type=script&lang=js"
export * from "./TagsModal.vue?vue&type=script&lang=js"

import "./TagsModal.vue?vue&type=style&index=0&id=6fb24c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb24c14"],['__file',"src/components/TagsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fb24c14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fb24c14', __exports__)) {
    api.reload('6fb24c14', __exports__)
  }
  
  module.hot.accept("./TagsModal.vue?vue&type=template&id=6fb24c14&scoped=true", () => {
    api.rerender('6fb24c14', render)
  })

}


export default __exports__